import { useCrossSellTracker } from "@packages/polling-checker/index"
import { Button, Card, Text } from "@shopify/polaris"
import { XIcon } from "@shopify/polaris-icons"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"

import { LINK_BOOK_A_DEMO } from "@/consts/link"
import { CROSS_SELL_POINT_ENUM } from "@/enums/CrossSellPoint"
import { ContactGroup } from "@/pages/Dashboard/components/ContactGroup"
import { openLink } from "@/utils/redirectShopify"

interface CrossSellBannerProps {
  isChina?: boolean
  onClose?: () => void
}
const CrossSellBanner = ({ onClose }:CrossSellBannerProps) => {
  const { t } = useTranslation("dashboard")
  const [popoverActive, setPopoverActive] = useState(false)

  useCrossSellTracker(() => window.CrossSellTracker?.logViewed(CROSS_SELL_POINT_ENUM.BannerContact))

  return <Card padding={"400"}>
    <div className={"flex justify-between"}>
      <div className={"flex max-w-max justify-between flex-wrap"}>
        <div className={"flex gap-3 flex-col max-w-[774px] sm:w-[70%] lg:w-[774px]"}>
          <Text as={"p"} variant={"headingSm"}>{t("CrossSellNewBannerTitle")}</Text>
          <Text as={"p"}>{t("CrossSellNewBannerDescription")}</Text>
          <div className={"flex flex-wrap gap-2"}>
            <ContactGroup
              CROSS_SELL_POINT={CROSS_SELL_POINT_ENUM.BannerContact}
              popoverActive={popoverActive}
              setPopoverActive={setPopoverActive}
              utm="T-onboarding"
              children={<Button
                ariaExpanded
                variant="primary"
                disclosure
                onClick={() => setPopoverActive(!popoverActive)}
              >
                {t("ContactNow")}
              </Button>}
            />
            <Button variant={"secondary"}
              onClick={() => {
                const tracker = window.CrossSellTracker

                if (tracker?.redirectToDemo) {
                  tracker.redirectToDemo(
                    CROSS_SELL_POINT_ENUM.SpecialOfferContact,
                    LINK_BOOK_A_DEMO,
                  )
                } else {
                  openLink(LINK_BOOK_A_DEMO)
                }
              }}
            >{t("BookADemo")}</Button>
          </div>
        </div>
        <div className={"w-[100px]"}>
          <img className={"w-full"} src={"https://cdn.parcelpanel.com/assets/admin/images/book-a-demo.png"} />
        </div>
      </div>
      <div>
        <Button onClick={onClose} variant={"tertiary"} icon={XIcon} />
      </div>
    </div>
  </Card>
}

export default CrossSellBanner
